import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  ArrowLeft,
  House,
  MagnifyingGlass,
  Question
} from '@phosphor-icons/react';

const NotFound = () => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-lg w-full text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="text-[150px] font-bold leading-none bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
            404
          </div>
          <div className="mt-2 text-slate-400 text-lg">Page not found</div>
        </div>

        {/* Message */}
        <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-8 mb-8">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-amber-500/10 rounded-full flex items-center justify-center">
              <MagnifyingGlass className="w-8 h-8 text-amber-400" />
            </div>
          </div>
          
          <h1 className="text-2xl font-semibold text-white mb-3">
            Oops! This page doesn't exist
          </h1>
          
          <p className="text-slate-400 mb-4">
            The page you're looking for might have been moved, deleted, or perhaps never existed.
          </p>

          <div className="bg-slate-900/50 rounded-lg p-3 mb-6">
            <code className="text-sm text-slate-500 break-all">
              {location.pathname}
            </code>
          </div>

          <div className="text-sm text-slate-500">
            <Question className="w-4 h-4 inline mr-1" />
            Please check that you've entered the correct URL
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
          >
            <House className="w-5 h-5" />
            Go to Homepage
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-slate-700 hover:bg-slate-600 text-white font-medium rounded-lg transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Go Back
          </button>
        </div>

        {/* Question Links */}
        <div className="mt-8 pt-8 border-t border-slate-700">
          <p className="text-slate-500 text-sm mb-3">Need help? Try these:</p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/contact" className="text-blue-400 hover:text-blue-300 transition-colors">
              Contact Support
            </Link>
            <Link to="/features" className="text-blue-400 hover:text-blue-300 transition-colors">
              View Features
            </Link>
            <Link to="/pricing" className="text-blue-400 hover:text-blue-300 transition-colors">
              Pricing
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
